var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanWithoutBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.5C7.32 1.5 9 3.18 9 5.25C9 7.32 6.915 8.58375 6.915 8.58375M6.915 8.58375L6.915 6.88875M6.915 8.58375L8.79 8.58375M5.25 9C3.18 9 1.5 7.335 1.5 5.25C1.5 2.74875 3.585 1.5 3.585 1.5M3.585 1.5L1.71 1.5M3.585 1.5L3.585 3.165",
    stroke: "#1C1C1C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00024 7.62V14H13.0002C14.1002 14 15.0002 13.1 15.0002 12V2H7.64026",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 14V17C22.0002 18.66 20.6602 20 19.0002 20H18.0002C18.0002 18.9 17.1002 18 16.0002 18C14.9002 18 14.0002 18.9 14.0002 20H10.0002C10.0002 18.9 9.10024 18 8.00024 18C6.90024 18 6.00024 18.9 6.00024 20H5.00024C3.34024 20 2.00024 18.66 2.00024 17V14H13.0002C14.1002 14 15.0002 13.1 15.0002 12V5H16.8403C17.5603 5 18.2203 5.39001 18.5803 6.01001L20.2902 9H19.0002C18.4502 9 18.0002 9.45 18.0002 10V13C18.0002 13.55 18.4502 14 19.0002 14H22.0002Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22C17.1048 22 18.0002 21.1046 18.0002 20C18.0002 18.8954 17.1048 18 16.0002 18C14.8957 18 14.0002 18.8954 14.0002 20C14.0002 21.1046 14.8957 22 16.0002 22Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanWithoutBg);
export default __webpack_public_path__ + "static/media/vanWithoutBG.27b86063eb5e095da2524f579534897b.svg";
export { ForwardRef as ReactComponent };